import type { BorrowMarketRow } from '@/hooks/useBorrowMarkets'
import { cn } from '@/utils/cn'
import { FilterSelect } from '../shared/filterSelect'
import { GroupedFilterSelect } from '../shared/groupedFilterSelect'
import { BorrowLiquidityFilter } from './borrowLiquidityFilter'
import { BorrowMarketSizeFilter } from './borrowMarketSizeFilter'
import { useBorrowMarketsFilterData } from './useBorrowMarketsFilterData'

interface BorrowMarketsFilterControlsProps {
  borrowMarkets: BorrowMarketRow[]
  className?: string
}

export const BorrowMarketsFilterControls = ({ borrowMarkets, className }: BorrowMarketsFilterControlsProps) => {
  const { tokenFilterProps, collateralFilterProps, networkFilterProps, protocolFilterProps } =
    useBorrowMarketsFilterData(borrowMarkets)

  return (
    <div className={cn('flex w-fit flex-wrap items-center gap-2', className)}>
      <GroupedFilterSelect {...tokenFilterProps} scrollClassName="max-h-56" />
      <FilterSelect {...networkFilterProps} scrollClassName="max-h-56" />
      <FilterSelect {...protocolFilterProps} scrollClassName="max-h-56" />
      <GroupedFilterSelect {...collateralFilterProps} scrollClassName="max-h-56" />
      <BorrowMarketSizeFilter borrowMarkets={borrowMarkets} />
      <BorrowLiquidityFilter borrowMarkets={borrowMarkets} />
    </div>
  )
}
